import React, { useState } from 'react';
import { HStack, Button, Input, useColorModeValue } from '@chakra-ui/react';

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const [pageInput, setPageInput] = useState('');

  const textColor = useColorModeValue('gray.700', 'white');

  // Convert to numbers to ensure proper comparison
  const current = Number(currentPage);
  const total = Number(totalPages);

  const handlePageChange = (e) => {
    if (e.key === 'Enter') {
      const pageNumber = parseInt(pageInput, 10);
      if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= total) {
        onPageChange(pageNumber);
      }
      setPageInput('');
    }
  };

  return (
    <HStack mt={4} justifyContent="center">
      <Button
        onClick={() => onPageChange(current - 1)}
        isDisabled={current <= 1}
        colorScheme="blue"
      >
        Previous
      </Button>
      <Input
        value={pageInput}
        onChange={(e) => setPageInput(e.target.value)}
        onKeyPress={handlePageChange}
        width="50px"
        textAlign="center"
        placeholder={`${current}`}
        color={textColor}
      />
      <Button isDisabled colorScheme="blue">
        {current} / {total}
      </Button>
      <Button
        onClick={() => onPageChange(current + 1)}
        isDisabled={current >= total}
        colorScheme="blue"
      >
        Next
      </Button>
    </HStack>
  );
};

export default PaginationControls;
